module.exports = __webpack_public_path__ + "img/3-5.4edb06a9.png";